module.exports = __webpack_public_path__ + "img/goods_xq.7f557344.svg";